


































import {Component, PropSync, Watch} from 'vue-property-decorator'
import {Action} from 'vuex-class';
import BaseFilter from '@/components/Filter/BaseFilter';
import {notifyError, notifyWarning} from '@/utils/notify-helper';
import {BlacklistContactFilter} from "@/store/settings/blacklists/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({})
export default class BlackListContactsFilter extends BaseFilter<BlacklistContactFilter> {
  @PropSync('show') is_show!: boolean;
  @PropSync('filterProp') filterParent!: any;
  @PropSync('runFilter') run!: any;
  @Action("getBlackListContacts") actionGetBlacklistContacts: any;
  @Action("exportBlackListContacts") actionExport: any;

  defaultFilter(): BlacklistContactFilter {
    return {
      page_number: 1,
      blacklistId: undefined,
      msisdn: undefined,
      email: undefined
    };
  }

  filterKeys: object = {
    "blacklistId" : "blacklist",
  }

  created() {
    if (this.$route.params.id){
      this.filtered();
      this.scroll();
    }
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Contact",
        addititional_info: getTranslatedParams({...this.filter, blacklist: this.$route.params.id})
      }
      const resp = await this.actionGetBlacklistContacts({...this.filter, blacklistId: this.$route.params.id});
      await this.actionLog(this.logObject);
      if (resp.data.recipients?.length == 0) {
        this.is_last = true
        if (!nextPage) notifyWarning()
      } else {
        this.is_last = false
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }


  exportContacts(): void {
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Export",
      action_status: "success",
      object_type: "Contact",
      addititional_info: getTranslatedParams({black_list: this.filter.msisdn})
    };
    this.actionExport({blacklistId: this.$route.params.id, filter: this.filter}).then(()=>{
      this.actionLog(this.logObject);
    }).catch((error: any) => {
      this.actionLog({...this.logObject, action_status: 'failed'});
      notifyError(error);
    });
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: BlacklistContactFilter) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }
}
